// extracted by mini-css-extract-plugin
module.exports = {"doc-item":"doc-item","docItem":"doc-item","docs-slider":"docs-slider","docsSlider":"docs-slider","slick-slide":"slick-slide","slickSlide":"slick-slide"};